const INFO = {
	main: {
		title: "Dinsmoor Audio",
		name: "Dinsmoor Audio",
		email: "joe@dinsmooraudio.com",
		logo: "../logo.png",
	},

	socials: {
		instagram: "https://instagram.com/dinsmooraudio",
		email: "joe@dinsmooraudio.com"
	},

	homepage: {
		title: "Recording and Mixing Studio started in 2022 in Richmond, Virginia",
		description:
			"Dinsmoor Audio is a recording and mixing studio located in Richmond Virginia, that specializes in metal, metalcore, hardcore, and deathcore. ",
	},

	about: {
		title: "About us:",
		description:
			"Dinsmoor Audio was started in a small bedroom in a duplex in Richmond, Virginia. It has sinced moved to be a full band recording and mixing studio, serving the Richmond community. We've worked with local bands as well as solo acts.",
	},

	projects: [
		{
			title: "Hypocrite",
			description:
				"The debut single of Richmond Hardcore duo, Unforgotten",
			releasedate: "2024",
			logo: "../hypocrite.png",
			linkText: "View Single",
			link: "https://open.spotify.com/track/0HTDioW3kLuMX8hwJzX3x0?si=6cea8c8a544c4296",
		},
		{
			title: "Desert of Embers",
			description:
				"A new single by the Richmond Deathcore band Ill Doctrine",
			releasedate: "2024",
			logo: "../DOE.png",
			linkText: "View Song",
			link: "https://open.spotify.com/track/6DNjA6O6guuwNAdkuCEonB?si=d7723d2c42914650",
		},
		
		{
			title: "Relinquish. Repent. Revolt.",
			description:
				"The first EP of the Richmond, Virginia deathcore band Ill Doctrine",
			releasedate: "2024",
			logo: "../RRR.png",
			linkText: "View EP",
			link: "https://open.spotify.com/album/3mDqbcYZjdmw8BQ4xIcQTl?si=3M9buNHwRjGJNdTDoSUPGw",
		},


		{
			title: "Bareknuckle Boxing",
			description:
				"An instrumental progressive metal track by Christian Bachman",
			releasedate:"2022",
			logo: "../BKB.png",
			linkText: "View Song",
			link: "https://open.spotify.com/track/1CTUynGQ0fW61ARAyCsUKw?si=b343fee7dfc64f59",
		},

		{
			title: "Over the Creek",
			description:
				"A second addition to the library of instrumental progressive metal guitarist Christian Bachman",
			releasedate: "2022",
			logo: "../OTC.png",
			linkText: "View Song",
			link: "https://open.spotify.com/track/4mD1YmqfsRlZ0vra6IV5HE?si=ee7c509940984851",
		}
	],
};

export default INFO;
